import ApiService from './api.service';

export interface DevelopGitInfo {
  /** "owner/name" of the Pliable-owned repo, or null if none provisioned. */
  repo: string | null;
  branch?: string;
  /** GitHub URL to the develop branch. */
  url?: string;
  /** Current head SHA of the develop branch, or null. */
  sha?: string | null;
  /** SHA of the develop commit last imported into Develop, or null. */
  synced_sha?: string | null;
  /** True when Develop reflects the current develop head (sha === synced_sha). */
  in_sync?: boolean;
}

export interface DevelopCommit {
  sha: string;
  short_sha: string;
  /** Full commit message (markdown, as authored by `plb sync`). */
  message: string;
  author?: string | null;
  date?: string | null;
  /** GitHub URL to the commit. */
  url?: string | null;
}

export interface DevelopCommitsPage {
  commits: DevelopCommit[];
  has_more: boolean;
}

export interface PushJobStatus {
  ok?: boolean;
  /** RQ job status: queued | started | deferred | finished | failed. */
  job_status: string;
  job_result?: { pushed?: boolean; sha?: string } | null;
  error_message?: string | null;
  progress?: unknown;
}

class GitService {
  async getDevelop(): Promise<DevelopGitInfo> {
    return (await ApiService.getInstance().request('GET', '/git/develop')) as DevelopGitInfo;
  }

  async pushDevelop(): Promise<{ job_id: string }> {
    return (await ApiService.getInstance().request('POST', '/git/push-develop')) as {
      job_id: string;
    };
  }

  async pullDevelop(): Promise<{ job_id: string }> {
    return (await ApiService.getInstance().request('POST', '/git/pull-develop')) as {
      job_id: string;
    };
  }

  async getDevelopCommits(page = 1, perPage = 20): Promise<DevelopCommitsPage> {
    return (await ApiService.getInstance().request(
      'GET',
      `/git/develop/commits?page=${page}&per_page=${perPage}`
    )) as DevelopCommitsPage;
  }

  async getJobStatus(jobId: string): Promise<PushJobStatus> {
    return (await ApiService.getInstance().request(
      'GET',
      `/get-job-status/${jobId}`
    )) as PushJobStatus;
  }
}

export const gitService = new GitService();

/** RQ job statuses that mean the push is done (success or failure). */
export const TERMINAL_JOB_STATUSES = new Set(['finished', 'failed', 'stopped', 'canceled']);
